import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";
import { Fragment } from "react/jsx-runtime";

export const LoanClassificationReportTable: React.FC<BaseTablePropsType> = ({
	rows,
}) => {
	const loanClassificationTableHeaders = [
		"Classification",
		"Days at Risk",
		"Amount",
		"Rate",
		"Provision",
	];
	return (
		<BaseTable headers={loanClassificationTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => {
					return (
						<Fragment key={index}>
							<TableRow>
								<TableCell>{row?.classification}</TableCell>
								<TableCell>{row?.daysAtRisk ?? 600}</TableCell>
								<TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
								<TableCell>{row?.rate ?? 0}%</TableCell>
								<TableCell>
									{formatAmountDisplay(row?.provision ?? 0)}
								</TableCell>
							</TableRow>
							{index === 0 && (
								<TableRow>
									<TableCell
										colSpan={5}
										sx={{ backgroundColor: "var(--table-header-bg-color)" }}
									>
										Non-Peforming
									</TableCell>
								</TableRow>
							)}
						</Fragment>
					);
				})}
			</TableBody>
		</BaseTable>
	);
};
